import React from 'react';

function Upload() {
	return (
		<div className="space-y-6">
			<div className="md:flex md:items-center md:justify-between">
				<div className="min-w-0 flex-1">
					<h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
						素材上传
					</h2>
					<p className="mt-1 text-sm text-gray-500">
						上传和管理广告创意素材
					</p>
				</div>
			</div>
			
			<div className="bg-white shadow rounded-lg p-6">
				<p className="text-gray-600">素材上传页面正在开发中...</p>
			</div>
		</div>
	);
}

export default Upload;
